import { Injectable } from "@angular/core";
import { fromEvent } from "rxjs";
import { distinctUntilChanged, filter } from "rxjs/operators";
import { DialogComponent } from "./dialog.component";


@Injectable({providedIn: 'root'})
export class DialogService {

    constructor(){
        fromEvent<KeyboardEvent>(document,'keydown').pipe(
            filter((e: KeyboardEvent) => e.keyCode === 27),
            distinctUntilChanged()
        ).subscribe(x =>{
            if (this.openedDialogs.length) {
                this.closeTopDialog();
            }
        })
    }

    openedDialogs:DialogComponent[] = [];

    openDialog(dialog:DialogComponent){
        this.openedDialogs.push(dialog);
    }

    closeDialog(dialog:DialogComponent){
      this.openedDialogs = this.openedDialogs.filter(x => x != dialog);
      if (!this.openedDialogs.length) {
        const htmlTag = document.querySelector('html');
        htmlTag?.classList.remove('dialogForm-locked');
      }
    }

    closeTopDialog(){
        const d = this.openedDialogs[this.openedDialogs.length - 1];
        if(d && !d.disableESC){
            d.hide();
        }
    }
}